import React from "react";
import { Typography, Box, IconButton } from "@mui/material";

export default function IconWithText({ icon, text, onClick, ...props }) {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      {...props}
    >
      <IconButton color="primary" onClick={onClick}>
        {icon}
      </IconButton>
      <Typography
        variant="caption"
        onClick={onClick}
        style={{
          cursor: "pointer",
          color: "black", // Adjust the color to match your theme
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
